import {
    Component, 
    Input, 
    Output, 
    ElementRef,
    EventEmitter,
    HostBinding,
    SimpleChanges,
    ViewChild
} from '@angular/core';

@Component({
selector: 'pm-filter-box',
//templateUrl: './app/controls/components/boxes/filter-box/filter-box.html',
templateUrl: './filter-box.html',
})
export class FilterBoxComponent {
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/boxes/filter-box/filter-box-component.ts